import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { Link } from 'react-router-dom';

const CHROME_URL = 'https://chrome.google.com/webstore/detail/MoonSkins.GG';
const FIREFOX_URL = 'https://addons.mozilla.org/en-US/firefox/addon/MoonSkinsGG';

const Help = () => {
  const { t } = useTranslation();


  return (
      <div className="flex flex-col text-sm font-semibold text-gray-500 dark:text-neutral-300 gap-2 mb-4 lg:mb-0">
        <div className="text-lg text-dark-primary mb-3">{t('footer.help')}</div>
        <Link to="/contact">{t('footer.contact')}</Link>
        <Link to="/faq">{t('footer.faq')}</Link>
        <div className="flex flex-col gap-1.5">
          <span>Extension</span>
          <div className="flex items-center gap-2">
            <a href={CHROME_URL} target="_blank" rel="noopener noreferrer" className="p-1.5 bg-white dark:bg-white/5 border border-neutral-200 dark:border-white/10 rounded-lg hover:bg-neutral-100 dark:hover:bg-white/10 hover:border-dark-primary/50 transition-all" title="Chrome Extension">
              <img src="https://upload.wikimedia.org/wikipedia/commons/e/e1/Google_Chrome_icon_%28February_2022%29.svg" alt="Chrome" className="w-4 h-4" />
            </a>
            <a href={FIREFOX_URL} target="_blank" rel="noopener noreferrer" className="p-1.5 bg-white dark:bg-white/5 border border-neutral-200 dark:border-white/10 rounded-lg hover:bg-neutral-100 dark:hover:bg-white/10 hover:border-dark-primary/50 transition-all" title="Firefox Extension">
              <img src="https://upload.wikimedia.org/wikipedia/commons/a/a0/Firefox_logo%2C_2019.svg" alt="Firefox" className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
  );
};

export default Help;